/* The Katha: homepage bed playground (kh-studio, "Let visitors recolour the bed"). Oct 2026.
   Two views of one bed:
   - photo: the Bundle Studio's layered front render (katha-bed-photo.js). Real fabric photos where we have
     them, otherwise the white render tinted with the swatch colour (same preview as the builder).
   - every layer: a drawn bed that pulls apart into mattress, fitted sheet, flat sheet, duvet cover and two
     pairs of pillowcases, so the fitted sheet can be seen and coloured too.
   Tap a piece (on the bed or its button), pick a colour, try a look or shuffle. "Finish this bed" opens the
   builder with the same colours (#bundle=… link).
   When the section ships recolour photos ([data-kbed-recolour], katha-bed-recolour.js), both views are real
   photos instead: the builder's bed photo per fabric, and an exploded photo of the layers, every piece coloured. */
(function () {
  /* start each bed only when it comes near the screen, so its photos don't load with the page */
  function start() {
    document.querySelectorAll('[data-kbed]').forEach(function (root) {
      if (!('IntersectionObserver' in window)) return init(root);
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); init(root); } }, { rootMargin: '600px 0px' });
      io.observe(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  var SVGNS = 'http://www.w3.org/2000/svg';

  function init(root) {
    if (root._kbed || !window.KathaBedPhoto) return; root._kbed = 1;
    var CAT, TX;
    try { CAT = JSON.parse(root.querySelector('[data-kbed-cat]').textContent); TX = JSON.parse(root.querySelector('[data-kbed-tx]').textContent); } catch (e) { return; }
    var $ = function (s) { return root.querySelector(s); };
    var PIECES = ['duvet', 'fitted', 'flat', 'back', 'front'];
    var SRC = { duvet: 0, fitted: 1, flat: 2, back: 3, front: 3 };   /* index into fabric.pieces */
    var NAMES = TX.pieces && TX.pieces.length === 5 ? TX.pieces : ['Duvet cover', 'Fitted sheet', 'Flat sheet', 'Back pillowcases', 'Front pillowcases'];
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

    var HEX = {};
    String(CAT.hex || '').split('\n').forEach(function (l) { var i = l.indexOf(':'); if (i > 0) HEX[l.slice(0, i).trim().toLowerCase()] = l.slice(i + 1).trim(); });
    var MO = {};
    (CAT.mo || []).forEach(function (m) { if (m && m.f && m.c) MO[String(m.f).toLowerCase() + '|' + String(m.c).toLowerCase().trim()] = m; });
    function mo(f, c) { return MO[String(f.key).toLowerCase() + '|' + String(c).toLowerCase()]; }

    /* a fabric is playable when every piece has at least one colour */
    var FABS = (CAT.fabrics || []).map(function (f) {
      f.pieces = (f.pieces || []).map(function (list) { return (list || []).filter(function (c) { var m = mo(f, c); return c && !(m && m.s === 'Hidden'); }); });
      return f;
    }).filter(function (f) { return f.pieces.length === 4 && f.pieces.every(function (l) { return l.length; }); });
    if (!FABS.length) return;

    function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
    function fab() { return FABS[state.f]; }
    function coloursFor(k, f) { f = f || fab(); return f.pieces[SRC[k]]; }
    function allColours(f) { var o = []; f.pieces.forEach(function (l) { l.forEach(function (c) { if (o.indexOf(c) < 0) o.push(c); }); }); return o; }
    /* swatch paint (may be a stripe pattern) and one flat colour for tinting and drawing */
    function paint(c, f) { var k = String(c).toLowerCase(); if (/gradient/.test(HEX[k] || '')) return HEX[k]; var m = mo(f || fab(), c); if (m && m.h) return m.h; return HEX[k] || '#E6E1DB'; }   // stripes keep their pattern
    function flat(c, f) { var p = paint(c, f), m = p.match(/#[0-9a-f]{6}/i); return m ? m[0] : p; }
    function stripes(c, f) { var p = paint(c, f); var m = p.match(/#[0-9a-f]{6}/ig); return /gradient/.test(p) && m && m.length > 1 ? m : null; }
    function realPhoto(c, f) { f = f || fab(); var m = mo(f, c); if (m && m.r) return m.r; return (f.renders || {})[c] || ''; }

    /* ---------- state ---------- */
    var state = { f: 0, piece: 'duvet', c: {}, view: 'photo', apart: false, spin: 0 };
    function pick(k, want, i) { var cs = coloursFor(k); for (var n = 0; n < want.length; n++) if (cs.indexOf(want[n]) > -1) return want[n]; return cs[i % cs.length]; }
    function seed() {
      state.c = {
        duvet: pick('duvet', ['Sage', 'Forest', 'Lavender'], 0),
        fitted: pick('fitted', ['Rice', 'Cream', 'Ivory'], 1),
        flat: pick('flat', ['Rice', 'Cream', 'Ivory'], 1),
        back: pick('back', ['Flax', 'Cream', 'Cloud'], 2),
        front: pick('front', ['Fawn', 'Mint', 'Sky'], 3)
      };
    }
    /* keep colours that exist in the new fabric, else fall back */
    function fit() { PIECES.forEach(function (k, i) { var cs = coloursFor(k); if (cs.indexOf(state.c[k]) < 0) state.c[k] = cs[i % cs.length]; }); }
    seed();

    /* ---------- photo view ---------- */
    var photoEl = $('[data-kbed-photo]');
    var layersEl = $('[data-kbed-layers]');
    var RC = null; try { var rcEl = root.querySelector('[data-kbed-recolour]'); if (rcEl) RC = JSON.parse(rcEl.textContent); } catch (e) {}
    var rPhoto = RC && RC.photo && window.KathaBedRecolour ? window.KathaBedRecolour(photoEl, RC.photo) : null;
    var rLayers = rPhoto && RC.layers && layersEl ? window.KathaBedRecolour(layersEl, RC.layers) : null;
    var photo = rPhoto ? { stage: null } : window.KathaBedPhoto(photoEl);
    /* colour for the recolour photos: a stripe's real widths come from its swatch pattern (4.5 px per cm) */
    function lum(h) { var n = parseInt(h.slice(1), 16); return (n >> 16 & 255) * .3 + (n >> 8 & 255) * .59 + (n & 255) * .11; }
    function paintFor(c) {
      var p = paint(c), stops = [], re = /(#[0-9a-f]{6})\s+([\d.]+)(?:px)?\s+([\d.]+)px/gi, m;
      if (/gradient/.test(p)) {
        while ((m = re.exec(p))) stops.push({ c: m[1], a: +m[2], b: +m[3] });
        if (stops.length > 1) return { name: c, hex: stops[0].c, stripe: stops[1].c, w: (stops[1].b - stops[1].a) / stops[1].b, period: stops[1].b / 4.5 };
        var hs = (p.match(/#[0-9a-f]{6}/gi) || []).sort(function (x, y) { return lum(y) - lum(x); });
        if (hs.length > 1) return { name: c, hex: hs[0], stripe: hs[1], w: .1 };
      }
      return { name: c, hex: flat(c) };
    }
    function want(extra) {
      var o = { fabric: fab().key, bolster: null, shams: null };
      PIECES.forEach(function (k) { o[k] = paintFor(state.c[k]); });
      if (extra) for (var x in extra) o[x] = extra[x];
      return o;
    }
    /* labels on the exploded photo, pinned to each piece's right-hand edge */
    var labs = {};
    function placeLabels() {
      if (!rLayers || state.view !== 'layers') return;
      var a = rLayers.anchors(); if (!a) return;
      PIECES.forEach(function (k, i) {
        var el = labs[k];
        if (!el) { el = labs[k] = document.createElement('span'); el.className = 'kh-l__lab'; layersEl.appendChild(el); }
        el.textContent = NAMES[i].toLowerCase() + ', ' + String(state.c[k]).toLowerCase();
        el.classList.toggle('is-sel', k === state.piece);
        if (!a[k]) { el.hidden = true; return; }
        el.hidden = false; el.style.top = Math.round(a[k][1]) + 'px';
        /* no room on the right (phones): tuck the label inside the photo on a light ground */
        var x = Math.round(a[k][0] + 10), room = layersEl.clientWidth - 6;
        el.classList.remove('is-in'); el.style.left = x + 'px';
        if (x + el.offsetWidth > room) { el.classList.add('is-in'); el.style.left = Math.max(6, room - el.offsetWidth) + 'px'; }
      });
    }
    if (rLayers) window.addEventListener('resize', placeLabels);
    var spinBtn = root.querySelector('[data-view="spin"]'); if (spinBtn && RC && RC.photo && RC.photo.spin && rPhoto) spinBtn.hidden = false;
    function srcFor(c) {
      var r = realPhoto(c); if (r) return { img: r };
      if (!CAT.base) return null;
      return { tint: flat(c), base: CAT.base };
    }
    function drawPhoto() {
      if (rPhoto) {
        rPhoto.set(want(state.view === 'spin' ? { spin: state.spin } : null));
        if (rLayers && state.view === 'layers') rLayers.set(want()).then(placeLabels);
        var nt = $('[data-kbed-note]');
        if (nt) { nt.hidden = state.view !== 'spin'; if (state.view === 'spin') nt.textContent = TX.spinNote || 'drag to turn the bed'; }
        return;
      }
      photo.set({ duvet: srcFor(state.c.duvet), flat: srcFor(state.c.flat), back: srcFor(state.c.back), front: srcFor(state.c.front) });
      var tinted = ['duvet', 'flat', 'back', 'front'].some(function (k) { return !realPhoto(state.c[k]); });
      var note = $('[data-kbed-note]'); if (note) note.hidden = !(tinted && state.view === 'photo');
    }
    /* a soft flash over the piece you just chose, so you see where it is */
    var MASK = window.KathaBedPhoto.MASK || {};
    function flash(k) {
      if (rPhoto) {
        if (reduce) return;
        var v = state.view === 'layers' && rLayers ? rLayers : rPhoto, sp = state.view === 'spin' ? { spin: state.spin } : {};
        v.set(want(Object.assign({ flash: k }, sp))); setTimeout(function () { v.set(want(sp)); }, 260);
        return;
      }
      if (reduce || state.view !== 'photo' || !photo.stage) return;
      var m = k === 'duvet' ? MASK.bed : k === 'flat' ? MASK.band : (k === 'back' || k === 'front') ? MASK.pillows : null;
      if (!m) return;
      var d = document.createElement('div');
      d.className = 'kh-bed__flash';
      d.style.webkitMaskImage = m; d.style.maskImage = m; d.style.webkitMaskSize = '100% 100%'; d.style.maskSize = '100% 100%';
      if (k === 'back') d.style.transform = 'translateY(-2.1%) scale(.972)';
      photo.stage.appendChild(d);
      setTimeout(function () { d.remove(); }, 900);
    }

    /* ---------- every-layer view (drawn) ---------- */
    var svg = null, G = {}, LIFT = { base: 0, fitted: 44, flat: 88, duvet: 132, back: 196, front: 222 };
    function P3(x, y, z) { return [((x - y) * 0.866).toFixed(1), ((x + y) * 0.5 - z).toFixed(1)]; }
    function poly(pts) { return pts.map(function (p) { return p.join(','); }).join(' '); }
    /* a box: top, foot (+y) and right (+x) faces, each a colour with a shade over the sides */
    function box(g, x, y, z, w, d, h, fill, round) {
      var x1 = x + w, y1 = y + d, z1 = z + h;
      var faces = [
        { pts: [P3(x, y, z1), P3(x1, y, z1), P3(x1, y1, z1), P3(x, y1, z1)], sh: 0 },
        { pts: [P3(x, y1, z1), P3(x1, y1, z1), P3(x1, y1, z), P3(x, y1, z)], sh: 0.1 },
        { pts: [P3(x1, y, z1), P3(x1, y1, z1), P3(x1, y1, z), P3(x1, y, z)], sh: 0.2 }
      ];
      faces.forEach(function (f) {
        var a = document.createElementNS(SVGNS, 'polygon');
        a.setAttribute('points', poly(f.pts)); a.setAttribute('class', 'kh-l__f'); a.style.fill = fill;
        if (round) { a.style.stroke = fill; a.setAttribute('stroke-width', round); a.setAttribute('stroke-linejoin', 'round'); }
        g.appendChild(a);
        if (f.sh) {
          var s = document.createElementNS(SVGNS, 'polygon');
          s.setAttribute('points', poly(f.pts)); s.setAttribute('fill', '#141414'); s.setAttribute('opacity', f.sh); s.setAttribute('pointer-events', 'none');
          g.appendChild(s);
        }
      });
    }
    var patN = 0;
    function fillFor(c) {
      var st = stripes(c); if (!st) return flat(c);
      var id = 'khp' + root.id + (++patN);
      var pt = document.createElementNS(SVGNS, 'pattern');
      pt.setAttribute('id', id); pt.setAttribute('patternUnits', 'userSpaceOnUse'); pt.setAttribute('width', 5); pt.setAttribute('height', 5); pt.setAttribute('patternTransform', 'rotate(30)');
      pt.innerHTML = '<rect width="5" height="5" fill="' + st[0] + '"/><rect width="1.4" height="5" fill="' + st[1] + '"/>';
      svg.querySelector('defs').appendChild(pt);
      return 'url(#' + id + ')';
    }
    function layer(key, pickable) {
      var g = document.createElementNS(SVGNS, 'g');
      g.setAttribute('class', 'kh-l kh-l--' + key);
      if (pickable) g.setAttribute('data-p', key);
      svg.appendChild(g); G[key] = g; return g;
    }
    function label(g, key, x, y, z) {
      var t = document.createElementNS(SVGNS, 'text');
      var p = P3(x, y, z); t.setAttribute('x', +p[0] + 10); t.setAttribute('y', p[1]); t.setAttribute('class', 'kh-l__t');
      t.textContent = NAMES[PIECES.indexOf(key)].toLowerCase() + ', ' + String(state.c[key]).toLowerCase();
      g.appendChild(t);
    }
    function drawLayers() {
      if (!layersEl || rLayers) return;
      if (!svg) {
        svg = document.createElementNS(SVGNS, 'svg');
        svg.setAttribute('class', 'kh-l__svg'); svg.setAttribute('role', 'img');
        layersEl.appendChild(svg);
      }
      svg.innerHTML = '<defs></defs>'; G = {}; patN = 0;
      var c = state.c;
      var g = layer('base'); box(g, -4, -4, -16, 168, 208, 14, '#E6E1DB'); box(g, 0, 0, -2, 160, 200, 26, '#F8F6F2', 3);
      g = layer('fitted', 1); box(g, -1, -1, 0, 162, 202, 25, fillFor(c.fitted), 3); label(g, 'fitted', 161, -1, 25);
      g = layer('flat', 1); box(g, -6, 0, 25, 172, 200, 2, fillFor(c.flat), 2); label(g, 'flat', 166, 0, 27);
      g = layer('duvet', 1); box(g, -10, 46, 27, 180, 166, 9, fillFor(c.duvet), 4);
      var fold = document.createElementNS(SVGNS, 'g'); fold.setAttribute('class', 'kh-l__fold'); g.appendChild(fold);
      box(fold, -10, 46, 36, 180, 18, 2, fillFor(c.flat), 2);
      label(g, 'duvet', 170, 46, 36);
      g = layer('back', 1); box(g, 10, 6, 27, 66, 28, 14, fillFor(c.back), 6); box(g, 84, 6, 27, 66, 28, 14, fillFor(c.back), 6); label(g, 'back', 150, 6, 41);
      g = layer('front', 1); box(g, 14, 18, 27, 60, 26, 12, fillFor(c.front), 6); box(g, 86, 18, 27, 60, 26, 12, fillFor(c.front), 6); label(g, 'front', 146, 18, 39);
      svg.setAttribute('aria-label', NAMES.map(function (n, i) { return n + ': ' + c[PIECES[i]]; }).join(', '));
      place(true);
    }
    /* together: a tight frame on the made bed; apart: a taller frame with the layers lifted */
    function place(instant) {
      if (!svg) return;
      svg.setAttribute('viewBox', state.apart ? '-200 -305 480 510' : '-195 -95 360 300');
      Object.keys(G).forEach(function (k, i) {
        var g = G[k];
        g.style.transitionDelay = instant || reduce ? '0s' : (state.apart ? i * 0.06 : (5 - i) * 0.04) + 's';
        g.style.transform = 'translateY(' + (state.apart ? -LIFT[k] : 0) + 'px)';
        g.classList.toggle('is-sel', g.getAttribute('data-p') === state.piece);
      });
      layersEl.classList.toggle('is-apart', state.apart);
      var btn = $('[data-kbed-apart]'); if (btn) btn.textContent = state.apart ? (TX.together || 'make the bed again') : (TX.apart || 'pull the layers apart');
    }

    /* ---------- tapping the bed ---------- */
    var P = window.KathaBedPhoto.P;
    function inPoly(x, y, pts) {
      var c = false;
      for (var i = 0, j = pts.length - 1; i < pts.length; j = i++) {
        var xi = pts[i][0], yi = pts[i][1], xj = pts[j][0], yj = pts[j][1];
        if (((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi)) c = !c;
      }
      return c;
    }
    function pieceAt(ev) {
      if (rPhoto) return (state.view === 'layers' && rLayers ? rLayers : rPhoto).pieceAt(ev);
      if (state.view === 'layers') { var g = ev.target.closest && ev.target.closest('[data-p]'); return g ? g.getAttribute('data-p') : null; }
      if (!P || !photo.stage) return null;
      var r = photo.stage.getBoundingClientRect();
      var x = (ev.clientX - r.left) / r.width * 100, y = (ev.clientY - r.top) / r.height * 100;
      if (inPoly(x, y, P.pillowL) || inPoly(x, y, P.pillowR)) return 'front';
      if (y > 30.6 && y < 34.6 && x > 31 && x < 68) return 'back';
      if (inPoly(x, y, P.band)) return 'flat';
      if (inPoly(x, y, P.bed)) return 'duvet';
      return null;
    }
    var media = photoEl.parentNode, tag = $('[data-kbed-tag]');
    media.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (e.target.closest('button')) { tag.classList.remove('is-on'); return; }
      var k = pieceAt(e);
      media.classList.toggle('is-over', !!k);
      if (!k) { tag.classList.remove('is-on'); return; }
      var mr = media.getBoundingClientRect();
      tag.textContent = NAMES[PIECES.indexOf(k)] + ', ' + String(state.c[k]).toLowerCase();
      tag.style.transform = 'translate(' + Math.round(e.clientX - mr.left + 14) + 'px,' + Math.round(e.clientY - mr.top + 14) + 'px)';
      tag.classList.add('is-on');
    });
    media.addEventListener('pointerleave', function () { tag.classList.remove('is-on'); media.classList.remove('is-over'); });
    /* 360°: drag across the bed to turn it, about 40 px per 30° */
    var drag = null;
    media.addEventListener('pointerdown', function (e) { if (state.view !== 'spin' || e.target.closest('button')) return; drag = { x: e.clientX, i: state.spin, moved: false }; });
    media.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var step = Math.round((drag.x - e.clientX) / 40);
      if (step) drag.moved = true;
      if (drag.i + step !== state.spin) { state.spin = drag.i + step; drawPhoto(); }
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) { media.addEventListener(t, function () { if (drag) setTimeout(function () { drag = null; }, 0); }); });
    media.addEventListener('click', function (e) {
      if (e.target.closest('button') || (drag && drag.moved)) return;
      var k = pieceAt(e); if (!k) return;
      choose(k);
      root.classList.remove('is-nudge'); void root.offsetWidth; root.classList.add('is-nudge');
      var sw = $('[data-kbed-swatches] button');
      if (window.innerWidth < 768 && sw) sw.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
    });

    /* ---------- views ---------- */
    function setView(v, apart) {
      state.view = v;
      root.querySelectorAll('[data-view]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-view') === v ? 'true' : 'false'); });
      root.classList.toggle('is-layers', v === 'layers');
      photoEl.hidden = v === 'layers';
      media.classList.toggle('is-spin', v === 'spin');
      layersEl.hidden = v !== 'layers';
      $('[data-kbed-apart]').hidden = v !== 'layers' || !!rLayers;
      if (v === 'layers' && rLayers) { drawPhoto(); return; }
      if (v === 'layers') {
        if (!svg) drawLayers();
        if (apart !== undefined && apart !== state.apart) { state.apart = apart; requestAnimationFrame(function () { requestAnimationFrame(function () { place(); }); }); }
      }
      drawPhoto();
    }
    root.querySelectorAll('[data-view]').forEach(function (b) {
      b.addEventListener('click', function () { var v = b.getAttribute('data-view'); setView(v, v === 'layers' ? true : undefined); });
    });
    $('[data-kbed-apart]').addEventListener('click', function () { state.apart = !state.apart; place(); });

    /* ---------- controls ---------- */
    var fabEl = $('[data-kbed-fabrics]'), pcEl = $('[data-kbed-pieces]'), swEl = $('[data-kbed-swatches]'), lkEl = $('[data-kbed-looks]');
    function bg(p) { return /gradient/.test(p) ? 'background-image:' + p : 'background:' + p; }
    function renderFabrics() {
      var fk = String(fab().key || '').toLowerCase();   /* swatch texture follows the fabric (CSS [data-tex]) */
      root.setAttribute('data-tex', /eucalyptus/.test(fk) ? 'eucalyptus' : /cotton/.test(fk) ? 'cotton' : 'linen');
      if (FABS.length < 2) { fabEl.hidden = true; return; }
      fabEl.innerHTML = FABS.map(function (f, i) {
        return '<button type="button" class="kh-chip kh-tab" data-f="' + i + '" aria-pressed="' + (i === state.f) + '">' + esc(f.label) +
          ' <span class="kh-chip__n">' + allColours(f).length + '</span></button>';
      }).join('');
    }
    function renderPieces() {
      pcEl.innerHTML = PIECES.map(function (k, i) {
        /* one compact row: a square of the piece's colour with a short name under it */
        var short = (TX.short || [])[i] || NAMES[i];
        return '<button type="button" class="kh-piece kh-pc" data-p="' + k + '" aria-pressed="' + (k === state.piece) + '" aria-label="' + esc(NAMES[i] + ', ' + state.c[k]) + '" title="' + esc(NAMES[i] + ': ' + state.c[k]) + '">' +
          '<span class="kh-dot" style="' + esc(bg(paint(state.c[k]))) + '"></span><span class="kh-pc__t">' + esc(short) + '</span></button>';
      }).join('');
    }
    function renderSwatches() {
      var lbl = (TX.pick || 'Colour for the [piece]').replace('[piece]', NAMES[PIECES.indexOf(state.piece)].toLowerCase());
      swEl.setAttribute('aria-label', lbl);
      swEl.innerHTML = coloursFor(state.piece).map(function (c) {
        var on = state.c[state.piece] === c;
        return '<button type="button" class="kh-sw" data-c="' + esc(c) + '" aria-pressed="' + on + '" title="' + esc(c) + '">' +
          '<span class="kh-sw__dot" style="' + esc(bg(paint(c))) + '"></span><span class="kh-sw__n">' + esc(c) + '</span></button>';
      }).join('');
    }
    var LOOKS = String(CAT.looks || '').split('\n').map(function (l) {
      var p = l.split('|').map(function (x) { return x.trim(); });
      if (p.length < 3) return null;
      return { name: p[0], fabric: p[1], c: p[2].split(',').map(function (x) { return x.trim(); }) };
    }).filter(function (l) {
      if (!l) return false;
      var f = FABS.filter(function (x) { return x.key === l.fabric; })[0]; if (!f) return false;
      return PIECES.every(function (k, i) { return !l.c[i] || coloursFor(k, f).indexOf(l.c[i]) > -1; });
    });
    function renderLooks() {
      if (!LOOKS.length || !TX.showLooks) { lkEl.hidden = true; return; }
      lkEl.innerHTML = LOOKS.map(function (l, i) {
        var f = FABS.filter(function (x) { return x.key === l.fabric; })[0];
        return '<button type="button" class="kh-look" data-look="' + i + '"><span class="kh-look__dots" aria-hidden="true">' +
          l.c.slice(0, 5).map(function (c) { return '<i style="' + esc(bg(paint(c, f))) + '"></i>'; }).join('') +
          '</span><span>' + esc(l.name) + '</span></button>';
      }).join('');
    }
    function renderText() {
      var f = fab(), c = state.c;
      var list = NAMES[0].toLowerCase() + ' in ' + c.duvet + ', ' + NAMES[1].toLowerCase() + ' in ' + c.fitted + ', ' + NAMES[2].toLowerCase() + ' in ' + c.flat +
        ', pillowcases in ' + (c.back === c.front ? c.back : c.back + ' and ' + c.front);
      $('[data-kbed-now]').textContent = (TX.now || 'On the bed: [list].').replace('[list]', list);
      var cur = $('[data-kbed-cur]');
      if (cur) cur.innerHTML = '<b>' + esc(NAMES[PIECES.indexOf(state.piece)]) + '</b> ' + esc(state.c[state.piece]);
      var ways = PIECES.reduce(function (n, k) { return n * coloursFor(k).length; }, 1);
      $('[data-kbed-ways]').textContent = (TX.ways || '').replace('[colours]', allColours(f).length).replace('[pieces]', PIECES.length).replace('[ways]', ways.toLocaleString('id-ID'));
      var pr = $('[data-kbed-price]');
      /* the investment view: the bundle price spread over five years of nights, to the nearest Rp 100 */
      var num = parseInt(String(f.price).replace(/[^\d]/g, ''), 10);
      var night = num ? 'Rp\u00a0' + (Math.round(num / (5 * 365) / 100) * 100).toLocaleString('id-ID') : '';
      pr.textContent = f.price ? (TX.price || '').replace('[fabric]', f.label.toLowerCase()).replace('[price]', String(f.price).replace(/ /g, '\u00a0')).replace('[night]', night) : '';
      pr.hidden = !f.price;
      var go = $('[data-kbed-go]');
      if (go) {
        var base = go.getAttribute('href').split('#')[0];
        go.setAttribute('href', base + '#bundle=' + encodeURIComponent([f.key, TX.size || 'Queen', 'standard', 'standard', c.duvet, c.fitted, c.flat, c.back, c.front].join('|')));
      }
    }
    function drawBed() { drawPhoto(); if (svg) drawLayers(); }
    function all() { renderFabrics(); renderPieces(); renderSwatches(); renderLooks(); renderText(); drawBed(); }
    function choose(k) {
      state.piece = k; renderPieces(); renderSwatches(); renderText(); flash(k);
      if (svg) place(true);
      if (rLayers) placeLabels();
      /* the fitted sheet is under the duvet in the drawn photo: show it in the layers view (the real photo shows it) */
      if (k === 'fitted' && state.view === 'photo' && !rPhoto) setView('layers', true);
    }

    fabEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-f]'); if (!b) return;
      var i = +b.getAttribute('data-f'); if (i === state.f) return;
      state.f = i; fit(); all();
    });
    pcEl.addEventListener('click', function (e) { var b = e.target.closest('[data-p]'); if (b) choose(b.getAttribute('data-p')); });
    swEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-c]'); if (!b) return;
      state.c[state.piece] = b.getAttribute('data-c');
      renderPieces(); renderSwatches(); renderText(); drawBed(); flash(state.piece);
    });
    lkEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-look]'); if (!b) return;
      var l = LOOKS[+b.getAttribute('data-look')];
      var fi = FABS.map(function (f) { return f.key; }).indexOf(l.fabric); if (fi < 0) return;
      state.f = fi;
      PIECES.forEach(function (k, i) { if (l.c[i]) state.c[k] = l.c[i]; });
      fit(); all();
    });
    swEl.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var bs = [].slice.call(swEl.querySelectorAll('button')), i = bs.indexOf(document.activeElement);
      if (i < 0) return; e.preventDefault();
      bs[(i + (e.key === 'ArrowRight' ? 1 : -1) + bs.length) % bs.length].focus();
    });

    /* shuffle: each piece changes in turn, duvet first, so you see the bed being made */
    var shuffleBtn = $('[data-kbed-shuffle]'), busy = false;
    if (shuffleBtn) shuffleBtn.addEventListener('click', function () {
      if (busy) return; busy = true;
      var next = {};
      PIECES.forEach(function (k) { var cs = coloursFor(k), c; do { c = cs[Math.floor(Math.random() * cs.length)]; } while (cs.length > 1 && c === state.c[k]); next[k] = c; });
      var step = reduce ? 0 : 160;
      PIECES.forEach(function (k, i) {
        setTimeout(function () {
          state.c[k] = next[k]; drawBed(); renderPieces();
          if (i === PIECES.length - 1) { renderSwatches(); renderText(); busy = false; }
        }, i * step);
      });
    });

    all();
    if (rPhoto) rPhoto.ready.then(function () { root.classList.add('is-live'); });
    var im = photoEl.querySelector('img');
    if (im) { var done = function () { root.classList.add('is-live'); }; if (im.complete && im.naturalWidth) done(); else im.addEventListener('load', done, { once: true }); }
  }
})();
